import { createRouter, createWebHistory } from 'vue-router';
const HomeView = () => import('../views/HomeView.vue');
const PrivacyPolicy = () => import('../views/PrivacyPolicy.vue');
const PrivacyPolicyShopNote = () => import('../views/PrivacyPolicy_shopNote.vue');
const PrivacyPolicyPrepList = () => import('../views/PrivacyPolicy_preplist.vue');
const TermsConditions = () => import('../views/TermsConditions.vue');
//const AmpsUpLanding = () => import('../views/AmpsUpLanding.vue')
const routes = [
    { path: '/', name: 'home', component: HomeView },
    { path: '/privacy', name: 'privacy', component: PrivacyPolicy },
    { path: '/privacy_shopnote', name: 'privacy_shop', component: PrivacyPolicyShopNote },
    { path: '/privacy_preplist', name: 'privacy_prep', component: PrivacyPolicyPrepList },
    { path: '/terms', name: 'terms', component: TermsConditions },
    //{ path: '/ampsup', name: 'ampsup', component: AmpsUpLanding },
    { path: '/:pathMatch(.*)*', redirect: '/' }
];
const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() { return { top: 0 }; }
});
export default router;
